// This powers the search panels - the homepage banner search and every Search Panel block - with
// their autocomplete, and passes the chosen filters on to the results page.
//
// A page can hold more than one panel, so each is set up on its own and everything is found by
// class within that panel. Each panel also says where it searches: its form's action is its
// results page and data-autocomplete-url its suggestions.

function UpdateParams(searchBox, subjectArea, studyMode, studyLocation, scqfLevel, availability)
{
    var url = new URL(window.location);
    url.searchParams.set("query", searchBox);
    url.searchParams.set("subject", subjectArea);
    url.searchParams.set("mode", studyMode);
    url.searchParams.set("campus", studyLocation);
    url.searchParams.set("level", scqfLevel);
    url.searchParams.set("available", availability);
    history.pushState(null, '', url);
}

var initSearchPanel = function (panel, fillFromUrl) {
    var $panel = $(panel);
    var $form = $panel.find('.search-box__form');
    var $query = $panel.find('.search-box__query');
    var $availability = $panel.find('.search-box__availability');
    var $mode = $panel.find('.search-box__mode');
    var $campus = $panel.find('.search-box__campus');
    var $level = $panel.find('.search-box__level');

    var hidden = {
        subject: $panel.find('.search-box__hidden-subject'),
        mode: $panel.find('.search-box__hidden-mode'),
        campus: $panel.find('.search-box__hidden-campus'),
        level: $panel.find('.search-box__hidden-level'),
        available: $panel.find('.search-box__hidden-available')
    };

    var availabilityValue = function () {
        return $availability.is(':checked') ? '1' : '0';
    };

    // Keeps the checkbox value and the form's hidden field in step with the tick.
    var syncAvailability = function () {
        var value = availabilityValue();
        $availability.val(value);
        hidden.available.val(value);
    };

    var selectedSubjects = function () {
        return $panel.find('.multi-select-header-option').map(function () { return $(this).data('value') }).get().join(',');
    };

    var currentFilters = function () {
        syncAvailability();

        return {
            query: $query.val(),
            subject: selectedSubjects(),
            mode: $mode.val() || '',
            campus: $campus.val() || '',
            level: $level.val() || '',
            available: availabilityValue()
        };
    };

    // Every value is URL-encoded, so a query holding "&" or "#" cannot break the link.
    var buildResultsUrl = function (params) {
        var query = Object.keys(params).map(function (key) {
            return key + '=' + encodeURIComponent(params[key] === undefined || params[key] === null ? '' : params[key]);
        }).join('&');

        return $form.attr('action') + '?' + query;
    };

    // Subject value to that subject's own landing page - only the training search has these.
    var subjectLandingPages = $panel.data('subject-landing-pages') || {};

    // A single subject with nothing typed, no campus and "Available courses only" unticked goes
    // straight to that subject's landing page, when it has one. Two or more subjects, or anything
    // else to search on, still goes to the results page - including the availability tick, as the
    // landing page lists every course, full ones too, and only the results page filters on it.
    // The Campus dropdown's "Campus" placeholder has the value 0.
    var landingPageFor = function (filters) {
        var subjects = filters.subject ? String(filters.subject).split(',') : [];
        var noQuery = $.trim(filters.query || '') === '';
        var noCampus = filters.campus === '' || filters.campus === '0';
        var notAvailableOnly = filters.available !== '1';

        if (noQuery && noCampus && notAvailableOnly && subjects.length === 1) {
            return subjectLandingPages[subjects[0]] || null;
        }

        return null;
    };

    // Repopulate the fields from the query string. Only one panel does this, so two panels on a
    // page don't both claim the same filters.
    if (fillFromUrl) {
        var searchParams = new URLSearchParams(window.location.search);

        if (searchParams.has('query')) {
            $query.val(searchParams.get('query'));
        }

        if (searchParams.has('subject')) {
            var param = searchParams.get('subject');
            var pickedSelection = panel.querySelector('.multi-select-selections');

            param.split(',').forEach(function (sub) {
                panel.querySelectorAll('.multi-select-option').forEach(function (option) {
                    if (option.dataset.value === sub) {
                        panel.querySelector('.reset-button').classList.remove('visuallyhidden');
                        option.classList.add('multi-select-selected');
                        pickedSelection.insertAdjacentHTML('afterend', `<span class="multi-select-header-option" data-value="${option.dataset.value}">${option.querySelector('.multi-select-option-text').innerHTML}</span>`);
                        panel.querySelector('.multi-select').insertAdjacentHTML('afterend', `<input type="hidden" name="subject[]" value="${option.dataset.value}">`);
                        pickedSelection.classList.add('visuallyhidden');
                    }
                });
            });
            hidden.subject.val(param);
        }

        if (searchParams.has('mode')) {
            $mode.val(searchParams.get('mode')).trigger('change');
            hidden.mode.val(searchParams.get('mode'));
        }

        if (searchParams.has('campus')) {
            $campus.val(searchParams.get('campus')).trigger('change');
            hidden.campus.val(searchParams.get('campus'));
        }

        if (searchParams.has('level')) {
            $level.val(searchParams.get('level')).trigger('change');
            hidden.level.val(searchParams.get('level'));
        }

        $availability.prop('checked', searchParams.has('available') && searchParams.get('available') === '1');
    }

    syncAvailability();

    // Keep the form's hidden fields in step with the filters. The submit handler below builds the
    // URL itself, but the fields keep the form complete should it ever submit without it.
    $panel.find('.multi-select.subject .multi-select-option').on('click', function () {
        hidden.subject.val(selectedSubjects());
    });

    $mode.on('change', function () {
        hidden.mode.val(this.value);
    });

    $campus.on('change', function () {
        hidden.campus.val(this.value);
    });

    $level.on('change', function () {
        hidden.level.val(this.value);
    });

    $availability.on('click', syncAvailability);

    $panel.find('.search-box__filter-button').on('click', function () {
        $panel.find('.search-box__row').toggleClass('active');
    });

    // Suggestions come from this panel's own endpoint. deferRequestBy waits for a pause in typing
    // rather than asking the server on every keystroke.
    $query.autocomplete({
        serviceUrl: $panel.data('autocomplete-url'),
        minChars: 2,
        deferRequestBy: 300,
        onSelect: function (value) {
            // Redirect
            if (value) {
                window.location.href = value.data;
            }
        }
    });

    // Every way of searching comes through here - Enter in the search box and the search icon
    // submit the form, and Filter & Search submits it too - so they all land in the same place.
    $form.on('submit', function (event) {
        event.preventDefault();

        var filters = currentFilters();

        var landingPage = landingPageFor(filters);
        if (landingPage) {
            location.href = landingPage;
            return;
        }

        UpdateParams(filters.query, filters.subject, filters.mode, filters.campus, filters.level, filters.available);

        location.href = buildResultsUrl(filters);
    });

    // Filter & Search sits outside the form, so it hands over to the form's submit.
    $panel.find('.search-box__search-button').on('click', function (event) {
        event.preventDefault();
        $form.trigger('submit');
    });

    // Popular search terms click event
    $panel.find('.multi-select-term-option').on('click', function () {
        location.href = buildResultsUrl({ query: $(this).text(), available: availabilityValue() });
    });
};

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.search-box__panel').forEach(function (panel, index) {
        initSearchPanel(panel, index === 0);
    });
});
